import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { media } from 'styled-bootstrap-grid';

import { TickCircleIcon } from '@root/styles/icons';

import BaseSectionContainer from '@common/components/SectionContainer';
import SectionHeader from '@common/components/SectionHeader';
import { BackgroundImgixWrapper } from '@common/components/BackgroundImgixWrapper';

export const SectionContainer = styled(BaseSectionContainer)`
  display: flex;
  align-items: stretch;
`;

export const BackgroundWrapper = styled.div`
  width: 50%;
  flex-shrink: 0;
  display: none;

  & > * {
    display: flex;
    flex: 1;
    height: 100%;
  }

  ${media.md`
    display: block;
    min-height: 600px;
    margin: 64px 0;
  `}
`;

export const Background = ({ src }) => (
  <BackgroundWrapper>
    <BackgroundImgixWrapper src={src} />
  </BackgroundWrapper>
);

export const FormRow = styled.div`
  display: flex;
  flex-direction: ${({ actionButtons }) => (actionButtons ? 'column-reverse' : 'column')};
  align-items: ${({ actionButtons }) => (actionButtons ? 'center' : 'initial')};
  margin: 30px 0;
  text-align: ${({ align }) => align || 'left'};

  button {
    margin-bottom: 5px;
  }

  ${media.xl`
    display: block;
    button {
      margin-bottom: 0;
      }
  `}
`;

export const Content = styled.div`
  padding: 64px;
  flex-grow: 5;
  font-size: 13px;
  text-align: center;
  color: #444;

  ${media.md`
    padding: 50px 100px 50px 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `}

  button {
    min-width: 150px;
  }
`;

export const Heading = styled(SectionHeader)`
  text-align: center;
  line-height: 2;
  margin: 0 0 20px 0;
  text-transform: unset;
  ${media.lg`
    text-align: left;
  `}
`;

export const FormInstruction = styled.p`
  margin-top: 15px;
  margin-bottom: 15px;
  line-height: 2;
  text-align: left;
  font-size: 16px;
`;

const StyledSuccessMessage = styled(FormInstruction)`
  display: flex;
  align-items: flex-start;

  svg {
    margin-right: 10px;
    margin-top: 4px;
    flex-shrink: 0;
    color: #41c429;
    width: 2em;
    height: 1.5em;
  }
`;

export const FormSuccessMessage = ({ children }) => (
  <StyledSuccessMessage>
    <TickCircleIcon />
    {children}
  </StyledSuccessMessage>
);

FormSuccessMessage.propTypes = {
  children: PropTypes.node.isRequired,
};
